﻿import { Inject, Injectable } from '@angular/core';
import { Observable, of, forkJoin } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch, map } from 'rxjs/operators';
import { PoliciesModule, PersonModule, RatingFactorModule, IUpdateAdditionalDisclosure, IAddedDisclosure, IUserAdditionalDisclosure, IUpdateAdditionalDisclosureDto } from '@shared/models/interfaces/elevate-data-models';
import { AppConsts } from '@shared/AppConsts';
import { HttpMethodBaseService } from './HttpMethodsBase/httpmethods-base';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from '../common/IDSVRAuthProviders/auth.service';
import { head } from 'lodash';
import { API_BASE_URL } from '@shared/service-proxies/service-proxies';

@Injectable()
export class UserDisclosuresService {
    constructor(
        private httpMethodBaseService: HttpMethodBaseService,
        private _authService: AuthService,
        @Inject(API_BASE_URL) private readonly API_BASE_URL
    ) { }


    getUserAdditionalDisclosures(userId: string, accessToken: string): Observable<IUserAdditionalDisclosure[]> {
        const url = this.API_BASE_URL + `/api/services/app/ClaimModify/GetUserDisclosures?accessToken=${accessToken}&userId=${userId}`;
        return this.httpMethodBaseService.get(url).pipe(map((res: { result: IUserAdditionalDisclosure[] }) => res.result));
    }

    updateUserAdditionalDisclosures(request: IUpdateAdditionalDisclosureDto): Observable<IAddedDisclosure[]> {
        let headers = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        });

        let body = {
            accessToken: request.accessToken,
            userId: request.userId,
            addOrUpdateDisclosures: request.addOrUpdateDisclosures,
            deleteDisclosures: request.deleteDisclosures
        };

        const url = `${this.API_BASE_URL}/api/services/app/ClaimModify/SetCustomUserDisclosures`;
        return this.httpMethodBaseService.post(url, body, headers).pipe(map((res: any) => res.result));
    }

}
